"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateMonitoringValues = updateMonitoringValues;
exports.default = void 0;

var _empty = require("rxjs/observable/empty");

var _merge = require("rxjs/observable/merge");

var _distinctUntilChanged = require("rxjs/operators/distinctUntilChanged");

var _tap = require("rxjs/operators/tap");

var _mergeMapTo = require("rxjs/operators/mergeMapTo");

var _map = require("rxjs/operators/map");

var _Subject = require("rxjs/Subject");

var _reduxObservable = require("redux-observable");

var _reactRouterRedux = require("react-router-redux");

var _monitoringTreeUtil = require("settings-ui-sdk/utils/monitoringTreeUtil");

var _AppActions = require("settings-ui-sdk/actions/AppActions");

var _Raven = _interopRequireDefault(require("Raven"));

var getDSN = function getDSN(rootModule) {
  return new _Subject.Subject().pipe((0, _distinctUntilChanged.distinctUntilChanged)(), (0, _tap.tap)(function (dsn) {
    try {
      _Raven.default.setDSN(dsn);
    } catch (e) {
      _Raven.default.setDSN(rootModule.dsn);
    }
  }), (0, _map.map)(_AppActions.sentryDsnChange));
};

var $newRelicAppId = new _Subject.Subject().pipe((0, _distinctUntilChanged.distinctUntilChanged)(), (0, _tap.tap)(function (newRelicAppId) {
  if (window.NREUM) {
    // New relic needs to be configured to run in QA, and doesn't work locally
    window.NREUM.info.applicationId = newRelicAppId;
  }
}), (0, _map.map)(_AppActions.newRelicAppIdChange));

function monitorLocationChanges(rootModule) {
  return function ($action) {
    var monitoringTree = (0, _monitoringTreeUtil.createMonitoringTree)(rootModule);
    return $action.ofType(_reactRouterRedux.LOCATION_CHANGE).pipe((0, _distinctUntilChanged.distinctUntilChanged)(function (a, b) {
      return a.payload.pathname === b.payload.pathname;
    }), (0, _tap.tap)(function () {
      getDSN(rootModule).next((0, _monitoringTreeUtil.findBestMonitoringValueForPath)('dsn', monitoringTree, window.location.pathname, rootModule.dsn));
      $newRelicAppId.next((0, _monitoringTreeUtil.findBestMonitoringValueForPath)('newRelicAppId', monitoringTree, window.location.pathname, rootModule.newRelicAppId));
    }), (0, _mergeMapTo.mergeMapTo)((0, _empty.empty)()));
  };
}

function updateMonitoringValues(rootModule) {
  return function () {
    return (0, _merge.merge)(getDSN(rootModule), $newRelicAppId);
  };
}

var _default = function _default(rootModule) {
  return (0, _reduxObservable.combineEpics)(monitorLocationChanges(rootModule), updateMonitoringValues(rootModule));
};

exports.default = _default;